export default __webpack_public_path__ + "static/media/bg_3.d7d874bb.png";